{
  "es": {
    "baseChip": {
      "states": {
        "included": "incluido",
        "excluded": "excluido"
      },
      "sortHint": "Usa las teclas de flecha para mover"
    }
  }
}
